//A JavaScript component for the Advanced Encryption Standard (AES). Fully compatible with Node.js.
import * as CryptoJS from "crypto-js";

export class CryptoJService {

	private _encryptionKey: string = "C51CE0D1-6498-491F-BF66-041927227CAD";
	public Crypto: any;
	public static $inject: Array<string> = [];
	constructor() {
		this.Crypto = CryptoJS;
	}

	encrypt(msg: string) {
		let msgObj = this.Crypto.AES.encrypt(msg, this._encryptionKey);
		return msgObj;
	}

	decrypt(encryptedText: string) {
		let msgObj = this.Crypto.AES.decrypt(encryptedText, this._encryptionKey);
		return msgObj.toString(this.Crypto.enc.Utf8);
	}

	encryptObject(msg: object) {
		let msgObj = this.Crypto.AES.encrypt(JSON.stringify(msg), this._encryptionKey);
		return msgObj;
	}

	decryptObject(encryptedObject: string) {
		let msgObj = this.Crypto.AES.decrypt(encryptedObject, this._encryptionKey);
		return JSON.parse(msgObj.toString(this.Crypto.enc.Utf8));
	}
}